import { DeleteButton } from '@common/components/forms';
import { YesNoConfirmModal } from '@common/components/modals';
import { IOrganizationRelationListingModel } from '@common/models/OrganizationRelationListingModel';
import { observer } from 'mobx-react';
import React, { useCallback, useState } from 'react';
import { Button, OverlayTrigger, Popover, Row, Tooltip } from 'react-bootstrap';
import { UserLocationsAdd } from './UserLocationsAdd';
import { UserStore } from './UserStore';
import { UserLocationsConfirmDeleteStore } from './UserLocationsConfirmDeleteStore';

interface IUserLocationsProps {
    store: UserStore;
    readOnly?: boolean;
}

const primaryLocationToolTip = observer(() => {
    return <Tooltip id="primaryLocationPopover">
        <span>A users primary location cannot be deleted here.</span>
    </Tooltip>
});

export const UserLocations = observer(({ store, readOnly }: IUserLocationsProps) => {
    const [confirmDeleteStore] = useState<UserLocationsConfirmDeleteStore>(new UserLocationsConfirmDeleteStore(store));
    const deleteOrganization = useCallback((hospitalOrg: IOrganizationRelationListingModel) => {
        confirmDeleteStore.show(hospitalOrg);
    }, [confirmDeleteStore]);
    
    const [addLocation, setAddLocation] = useState(false);

    const addLocationHandler = (): void => {
        setAddLocation(true);
    }

    return (
        <>
            {addLocation &&
                <UserLocationsAdd onClose={() => setAddLocation(false)} userStore={store} />}
            <YesNoConfirmModal
                visible={confirmDeleteStore.visible}
                title="Remove Access"
                description={confirmDeleteStore.description}
                busy={store.userLoading}
                onConfirm={async () => await confirmDeleteStore.confirm()}
                onCancel={confirmDeleteStore.close}
            />
            {!store.userHospitalOrganizations.length &&
                <Row className="pt-1">
                    <em>No locations have been assigned to this user.</em>
                </Row>
            }
            {store.userHospitalOrganizations.length > 0 &&
                <ul className="list-group">
                    {store.userHospitalOrganizations.map((r, index) =>
                        <li className="list-group-item no-border pt-2" key={r.organizationId}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <span>{r.organizationDescription ? r.organizationDescription : r.organizationName} {
                                    r.isDefault &&
                                    (
                                        <OverlayTrigger trigger="click" overlay={primaryLocationToolTip} rootClose>
                                            <strong><button className="btn btn-link shadow-none">(Primary)<i className="fa fa-exclamation-triangle text-info"></i></button></strong>
                                        </OverlayTrigger>
                                    )
                                }
                                    {r.hospitalCount > 1 &&
                                        (
                                            <OverlayTrigger trigger="click" rootClose overlay={<Popover id={'locationHospitalCount_' + index}>This location includes access to {r.hospitalCount} Hospital(s) {r.isReadOnly && 'and is read only and cannot be deleted here.'}</Popover>}>
                                                <span className="cursor-pointer">{r.hospitalCount}&nbsp;<i className="fa fa-exclamation-triangle text-info"></i></span>
                                            </OverlayTrigger>
                                        )
                                    }
                                </span>
                                {(!r.isDefault && !readOnly && !r.isReadOnly) && store.isActive &&
                                    < DeleteButton aria-label={`delete ${r.organizationDescription} role`} onClick={() => deleteOrganization(r)} />
                                }
                            </div>
                        </li>
                    )}
                </ul>
            }
            <Row className="pt-4">
                <div className="d-flex flex-column">
                    {!readOnly && store.isActive &&
                        <div className="actions">
                            <Button className="btn btn-secondary btn-outline-primary" onClick={addLocationHandler}>Add New Location</Button>
                        </div>
                    }
                </div>
            </Row>
         </>
    )
});
